import { BASE_ENDPOINT } from "../../../endpoint";

export const downloadDisbursedLoanReportService = async (
	token: string,
	filters: { [key: string]: string },
	type: string
): Promise<Blob> => {
	const reportType = type || "excel";
	const queryParams = new URLSearchParams({
		...filters,
		type: reportType,
	}).toString();
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/report/disbursedloan/download?${queryParams}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					Accept:
						reportType === "pdf"
							? "application/pdf"
							: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				},
			}
		);
		if (!response.ok) {
			console.error("Failed to download disbursed loan report");
			throw new Error("Failed to download disbursed loan report");
		}
		const blob = await response.blob();
		return blob;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
